import React from "react"
import styled from "styled-components"

import constants from "utils/constants"
export default function AchivementBlock({ totalAuthDayCount, stickerList, displayStickerNum }) {
	return (
		<BlockSection>
			<BlockLeft>
				<TopTxt>누적 인증 일수</TopTxt>
				<DayCount>{totalAuthDayCount ? `${totalAuthDayCount} 일` : `0 일`}</DayCount>
			</BlockLeft>
			<Splitter></Splitter>
			<BlockRight>
				<TopTxt>오늘 모은 스티커</TopTxt>
				<StickerSection>
					{stickerList?.length > 0
						? stickerList.map((sticker, index) => {
								if (index < displayStickerNum) {
									return (
										<StickerWrapper
											key={`achivement-block-sticker-item-${index}`}
										>
											<StickerImg
												src={`${constants["imagePath"]}/sticker/${sticker.file_name}`}
											/>
										</StickerWrapper>
									)
								}
								return null
						  })
						: `-`}
					{stickerList?.length > displayStickerNum ? (
						<StickerWrapper key={`achivement-block-sticker-item-additional-num`}>
							{`+${stickerList.length - displayStickerNum}`}
						</StickerWrapper>
					) : null}
				</StickerSection>
			</BlockRight>
		</BlockSection>
	)
}

export const BlockSection = styled.div`
	background: #fff2c8;
	border-radius: calc(100vw * (10 / 375));
	&:after {
		content: " ";
		display: block;
		clear: both;
	}
	display: flex;
	justify-content: space-around;
	position: relative;
	overflow: hidden;
	padding: calc(100vw * (15 / 375)) 0;
`

export const BlockLeft = styled.div`
	width: 50%;
	text-align: center;
`

export const DayCount = styled.div`
	font-style: normal;
	font-weight: bold;
	font-size: calc(100vw * (20 / 375));
	/* identical to box height */
	text-align: center;
	color: #3e414b;
`
export const Splitter = styled.div`
	position: absolute;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	margin: auto;
	width: 1px;
	height: 50%;
	box-sizing: border-box;
	background: #ffc907;
`
export const BlockRight = styled(BlockLeft)``

export const TopTxt = styled.span`
	font-style: normal;
	font-weight: 500;
	font-size: calc(100vw * (12 / 375));
	text-align: center;
	color: #545867;
	margin-bottom: calc(100vw * (8 / 375));
	display: inline-block;
`
export const StickerSection = styled.div`
	text-align: center;

	padding-left: calc(100vw * (11 / 375));
`
export const StickerWrapper = styled.div`
	display: inline-block;
	position: relative;
	border-radius: 100%;
	border: 2px solid #fff2c8;
	box-sizing: border-box;
	width: calc(100vw * (35 / 375));
	height: calc(100vw * (35 / 375));
	background: white;
	padding: calc(100vw * (5 / 375));
	margin-left: calc(100vw * (-11 / 375));
	line-height: calc(100vw * (21 / 375));
`
export const StickerImg = styled.img`
	width: 100%;
	height: 100%;
	object-fit: cover;

	image-rendering: -moz-crisp-edges; /* Firefox */
	image-rendering: -o-crisp-edges; /* Opera */
	image-rendering: -webkit-optimize-contrast; /* Webkit (non-standard naming) */
	image-rendering: crisp-edges;
	-ms-interpolation-mode: nearest-neighbor;
`
